import { autoinject } from "aurelia-dependency-injection";
import {computedFrom} from "aurelia-framework";
import {type VesselComparisonGovernanceDetails} from "../../../../../models/vessel-comparison/vessel-comparison.models";
import { SafetyRatingTypeEnum } from '@rightship-tech/common-ui/models/vessels/vessel.models';

@autoinject()
export class VesselComparisionGovernanceVm {
    private _vesselComparisonGovernanceDetails: VesselComparisonGovernanceDetails;
    isSanctioned: boolean;
    isFlagFake: boolean;

    @computedFrom("_vesselComparisonGovernanceDetails")
    get vesselComparisonGovernanceDetails(): VesselComparisonGovernanceDetails {
        return this._vesselComparisonGovernanceDetails;
    }

    set vesselComparisonGovernanceDetails(value: VesselComparisonGovernanceDetails) {
        this._vesselComparisonGovernanceDetails = value;
    }

    @computedFrom("_vesselComparisonGovernanceDetails.starRating")
    get subscoreType(): number {
        let result = SafetyRatingTypeEnum.FullScore;

        if (this._vesselComparisonGovernanceDetails.starRating <= 2) {
            result = SafetyRatingTypeEnum.NA;
        }
        
        return result;
    }

    constructor(vesselComparisonGovernanceDetails: VesselComparisonGovernanceDetails, isSanctioned: boolean, isFlagFake: boolean) {
        this.vesselComparisonGovernanceDetails = vesselComparisonGovernanceDetails;
        this.isSanctioned = isSanctioned;
        this.isFlagFake = isFlagFake;
    }
}